import { cva } from 'class-variance-authority'

// The "field" surface (STYLE_GUIDE.md → Controls): anything that holds or picks a value —
// select triggers, date/month pickers, text inputs — is a square, hairline-bordered box.
// Actions are pill Buttons; fields are never pills. Colors are foreground-relative so the
// same classes read correctly in light and dark.
export const fieldVariants = cva(
  'flex w-full items-center justify-between gap-2 border border-foreground/15 bg-transparent text-foreground transition-colors outline-none not-disabled:cursor-pointer not-disabled:hover:border-foreground/30 data-[state=open]:border-foreground/40 data-[state=open]:bg-foreground/5 data-placeholder:text-foreground/50 focus-visible:border-foreground/40 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        // Dense widget toolbars (calendar filters, table headers).
        xs: 'h-6 px-2 text-xs',
        sm: 'h-8 px-2.5 text-xs',
        default: 'h-10 px-3 text-sm',
      },
    },
    defaultVariants: { size: 'default' },
  }
)

// Trailing icon inside a field (chevron, calendar glyph).
export const fieldIconClassName =
  'text-foreground/50 size-3.5 shrink-0 transition-transform group-data-[state=open]:text-foreground'
